import { Circle as ChakraCircle, type SquareProps as ChakraCircleProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraCircleProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraCircle ref={ref} {...props} />
})
